<template>
  <div>
    <button
      data-test="report-control-yes"
      class="btn btn-primary"
      @click="select(true)"
      type="button"
    >
      Yes</button
    >&nbsp;
    <button
      data-test="report-control-no"
      class="btn btn-default"
      @click="select(false)"
      type="button"
    >
      No
    </button>
  </div>
</template>

<script setup lang="ts">
import axios from "axios";

const props = withDefaults(
  defineProps<{
    ids: string[];
    names: string[];
  }>(),
  {
    ids: () => [],
    names: () => [],
  },
);

const emit = defineEmits(["input"]);

function select(choiceInput: boolean): void {
  axios
    .patch("/api/reportpermissions/", {
      allow: choiceInput,
      ids: props.ids,
    })
    .then(() => {
      emit("input", choiceInput);
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>
